/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ListItemTypeEnum = "containers" | "external_contacts" | "internal_contacts" | "item" | "messages" | "shipments" | "tickets" | "vessels" | "voyages" | "%future added value";
export type FilterInput = {
    key: string;
    values: Array<string>;
};
export type ItemListHeaderQueryVariables = {
    searchQuery?: string | null;
    type?: ListItemTypeEnum | null;
    filters?: Array<FilterInput> | null;
    handoverDateStart?: string | null;
    handoverDateEnd?: string | null;
    voyageEtaStart?: string | null;
    voyageEtaEnd?: string | null;
    voyageEtdStart?: string | null;
    voyageEtdEnd?: string | null;
    dischargeDateStart?: string | null;
    dischargeDateEnd?: string | null;
    contactSlug?: string | null;
    sortKey?: string | null;
    includeArchived?: boolean | null;
    page?: number | null;
    perPage?: number | null;
};
export type ItemListHeaderQueryResponse = {
    readonly filterList: {
        readonly " $fragmentRefs": FragmentRefs<"ItemListHeader_data">;
    };
};
export type ItemListHeaderQuery = {
    readonly response: ItemListHeaderQueryResponse;
    readonly variables: ItemListHeaderQueryVariables;
};



/*
query ItemListHeaderQuery(
  $searchQuery: String
  $type: ListItemTypeEnum
  $filters: [FilterInput!]
  $handoverDateStart: Date
  $handoverDateEnd: Date
  $voyageEtaStart: Date
  $voyageEtaEnd: Date
  $voyageEtdStart: Date
  $voyageEtdEnd: Date
  $dischargeDateStart: Date
  $dischargeDateEnd: Date
  $contactSlug: String
  $sortKey: String
  $includeArchived: Boolean
  $page: Int
  $perPage: Int
) {
  filterList(searchQuery: $searchQuery, type: $type, filters: $filters, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, contactSlug: $contactSlug, sortKey: $sortKey, includeArchived: $includeArchived, page: $page, perPage: $perPage) {
    ...ItemListHeader_data
  }
}

fragment ItemListHeader_data on ItemList {
  sortKeys {
    key
    title
  }
  filters {
    key
    name
    values {
      label
      displayLabel
      selected
      count
    }
  }
  totalCount
  downloadToken
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateStart"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handoverDateEnd"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handoverDateStart"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortKey"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaEnd"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaStart"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdEnd"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdStart"
},
v16 = [
  {
    "kind": "Variable",
    "name": "contactSlug",
    "variableName": "contactSlug"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateEnd",
    "variableName": "dischargeDateEnd"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateStart",
    "variableName": "dischargeDateStart"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "handoverDateEnd",
    "variableName": "handoverDateEnd"
  },
  {
    "kind": "Variable",
    "name": "handoverDateStart",
    "variableName": "handoverDateStart"
  },
  {
    "kind": "Variable",
    "name": "includeArchived",
    "variableName": "includeArchived"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "perPage",
    "variableName": "perPage"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "sortKey",
    "variableName": "sortKey"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaEnd",
    "variableName": "voyageEtaEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaStart",
    "variableName": "voyageEtaStart"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdEnd",
    "variableName": "voyageEtdEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdStart",
    "variableName": "voyageEtdStart"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemListHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v16/*: any*/),
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "filterList",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ItemListHeader_data"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v11/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "ItemListHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v16/*: any*/),
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "filterList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SortKey",
            "kind": "LinkedField",
            "name": "sortKeys",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Filter",
            "kind": "LinkedField",
            "name": "filters",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterValue",
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "selected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downloadToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "04dbe67d5afb942b6f772c21dfd6f645",
    "id": null,
    "metadata": {},
    "name": "ItemListHeaderQuery",
    "operationKind": "query",
    "text": "query ItemListHeaderQuery(\n  $searchQuery: String\n  $type: ListItemTypeEnum\n  $filters: [FilterInput!]\n  $handoverDateStart: Date\n  $handoverDateEnd: Date\n  $voyageEtaStart: Date\n  $voyageEtaEnd: Date\n  $voyageEtdStart: Date\n  $voyageEtdEnd: Date\n  $dischargeDateStart: Date\n  $dischargeDateEnd: Date\n  $contactSlug: String\n  $sortKey: String\n  $includeArchived: Boolean\n  $page: Int\n  $perPage: Int\n) {\n  filterList(searchQuery: $searchQuery, type: $type, filters: $filters, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, contactSlug: $contactSlug, sortKey: $sortKey, includeArchived: $includeArchived, page: $page, perPage: $perPage) {\n    ...ItemListHeader_data\n  }\n}\n\nfragment ItemListHeader_data on ItemList {\n  sortKeys {\n    key\n    title\n  }\n  filters {\n    key\n    name\n    values {\n      label\n      displayLabel\n      selected\n      count\n    }\n  }\n  totalCount\n  downloadToken\n}\n"
  }
};
})();
(node as any).hash = '0a6981782a9ce4083eaa3bc9f06bb9cb';
export default node;
